import { Link } from "react-router-dom"
import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import { ChatIcon } from "src/icons"
import { Chip } from "../../components/Chip"
import { IBANSetupForm } from "./Form"
import "./style.scss"

export const IBANSetup = () => {
  return (
    <div className="setup-wrapper">
      <Container>
        <div className="setup">
          <div className="setup__details">
            <Chip icon={<ChatIcon />} title="Contact us" />
            <h1>Unlock the Future of Finance with Crypto IBAN</h1>
            <p>
              Unlock the Future of Finance with Crypto IBAN We’re excited to support your growth! Fill out the form, and we’ll get in touch
              to help you open your crypto IBAN account today.{" "}
            </p>
            <p>
              Not a business? <Link to="/register/personal">Click here</Link> to explore personal account options.
            </p>
            <Image src="logo_black.png" width={100} />
          </div>
          <IBANSetupForm />
        </div>
      </Container>
    </div>
  )
}
